



















































import { Component, Mixins, Prop } from 'vue-property-decorator';
import FirmTableMixins from '../../mixins/firmTableMixins';

@Component
export default class Certification extends Mixins(FirmTableMixins) {
  /** 表头定义 */
  @Prop({ type: Array, default: () => [] })
  private columns!: TypeBase.TableColumn[];
  /** 主体信息列表 */
  protected dataList: TypeCertification.RegisterProcessSignBodyResp[] = [];

  private created() {
    this.queryCustomerFirmList();
  }
}
